import React, { FunctionComponent, useState } from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { formatMoney } from 'accounting';
import ErrorStatusIcon from '../../components/StatusMessage/ErrorStatusIcon';
import { language } from '../../utils/language';
import { getReferenceDisplayText } from '../../utils/referencePresentation';
import { handleRebuyFromPurchase } from '../../redux/actions';
import { path } from '../../config/enviroment';
import {
    StatusBackdropFrame,
    AveonlineWrapper,
    StatusHeader,
    StatusBannerCard,
    OrderSummaryCard,
    NextStepCard,
    ShippingSummaryCard,
    ShadowCard,
    CardRow,
    CardColLeft,
    CardColRight,
    Label,
    SubLabel,
    OrderNumberRow,
    CopyButton,
    CopiedFeedback,
    EmailMessage,
    Amount,
    DateText,
    StatusTitle,
    StatusDescription,
    DayName,
    SectionTitle,
    ShippingGrid,
    ShippingGrid3,
    ShippingCol,
    ShippingValue,
    ProductsSection,
    ProductsSectionWrapper,
    ProductRow,
    ProductName,
    ProductMeta,
    ProductThumb,
    FooterRow,
    TextLink,
    OutlineButton,
    FilledButton,
    PrimaryActionButton,
    ErrorActions,
    CancelLink,
} from './PurchaseDetailAveonline.style';

type TransactionState = {
    transactionDate: string;
    transactionTime: string;
};

type Props = {
    purchase: any;
    transactionState: TransactionState;
    homeState: HomeStateType;
    payment: number;
    items: any[];
    idCart: string;
    handlePrint: () => void;
    status: 'success' | 'pending' | 'error';
    handleCheckout?: () => void;
    loading?: boolean;
    isTestTransaction?: boolean;
};

const CopyIcon = ({ size = 21 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M13.335 1.75H9.92775C8.38425 1.75 7.161 1.75 6.20463 1.8795C5.21938 2.0125 4.42225 2.2925 3.794 2.92338C3.16488 3.55425 2.88575 4.35488 2.75363 5.34363C2.625 6.30438 2.625 7.532 2.625 9.08163V14.1899C2.625 15.5094 3.43 16.6399 4.57363 17.1141C4.515 16.3179 4.515 15.2023 4.515 14.273V9.88925C4.515 8.76838 4.515 7.8015 4.61825 7.028C4.72938 6.1985 4.97963 5.404 5.62188 4.75913C6.26413 4.11425 7.056 3.86313 7.882 3.75113C8.652 3.64788 9.6145 3.64788 10.7319 3.64788H13.4181C14.5346 3.64788 15.4954 3.64788 16.2663 3.75113C16.0353 3.16163 15.6322 2.6554 15.1093 2.29844C14.5864 1.94147 13.9681 1.75036 13.335 1.75Z" fill="currentColor" />
        <path d="M5.78125 9.97028C5.78125 7.58503 5.78125 6.39241 6.51975 5.65128C7.25737 4.91016 8.44475 4.91016 10.8212 4.91016H13.3412C15.7169 4.91016 16.9051 4.91016 17.6436 5.65128C18.3821 6.39241 18.3812 7.58503 18.3812 9.97028V14.1878C18.3812 16.573 18.3812 17.7657 17.6436 18.5068C16.9051 19.2479 15.7169 19.2479 13.3412 19.2479H10.8212C8.44562 19.2479 7.25737 19.2479 6.51975 18.5068C5.78125 17.7657 5.78125 16.573 5.78125 14.1878V9.97028Z" fill="currentColor" />
    </svg>
);

const PrinterIcon = ({ width = 21, height = 18 }: { width?: number; height?: number }) => (
    <svg width={width} height={height} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M21 6V13.5C21 13.6989 20.921 13.8897 20.7803 14.0303C20.6397 14.171 20.4489 14.25 20.25 14.25H17.25V17.25C17.25 17.4489 17.171 17.6397 17.0303 17.7803C16.8897 17.921 16.6989 18 16.5 18H4.5C4.30109 18 4.11032 17.921 3.96967 17.7803C3.82902 17.6397 3.75 17.4489 3.75 17.25V14.25H0.75C0.551088 14.25 0.360322 14.171 0.21967 14.0303C0.0790176 13.8897 0 13.6989 0 13.5V6C0 4.75969 1.065 3.75 2.37469 3.75H3.75V0.75C3.75 0.551088 3.82902 0.360322 3.96967 0.21967C4.11032 0.0790178 4.30109 0 4.5 0H16.5C16.6989 0 16.8897 0.0790178 17.0303 0.21967C17.171 0.360322 17.25 0.551088 17.25 0.75V3.75H18.6253C19.935 3.75 21 4.75969 21 6ZM5.25 3.75H15.75V1.5H5.25V3.75ZM15.75 12H5.25V16.5H15.75V12ZM17.25 7.875C17.25 7.6525 17.184 7.43499 17.0604 7.24998C16.9368 7.06498 16.7611 6.92078 16.5555 6.83564C16.35 6.75049 16.1238 6.72821 15.9055 6.77162C15.6873 6.81502 15.4868 6.92217 15.3295 7.0795C15.1722 7.23684 15.065 7.43729 15.0216 7.65552C14.9782 7.87375 15.0005 8.09995 15.0856 8.30552C15.1708 8.51109 15.315 8.68679 15.5 8.8104C15.685 8.93402 15.9025 9 16.125 9C16.4234 9 16.7095 8.88147 16.9205 8.6705C17.1315 8.45952 17.25 8.17337 17.25 7.875Z" fill="currentColor" />
    </svg>
);

const PendingStatusIcon = () => (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.5 72C56.5538 72 72 56.5538 72 37.5C72 18.4462 56.5538 3 37.5 3C18.4462 3 3 18.4462 3 37.5C3 56.5538 18.4462 72 37.5 72ZM37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5C0 58.2107 16.7893 75 37.5 75Z"
            fill="#FFD100"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39 24.0018H36V46.6172H39V24.0018Z"
            fill="#FFD100"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39 48.7692H36V52H39V48.7692Z"
            fill="#FFD100"
        />
    </svg>
);

const DAY_NAMES_ESP = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const DAY_NAMES_ENG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const STATUS_MAP: Record<string, { titleKey: string; descKey: string }> = {
    'No Aplica': { titleKey: 'preparingOrder', descKey: 'preparingOrderDesc' },
    envio_programado: { titleKey: 'scheduledShipment', descKey: 'scheduledShipmentDesc' },
    pendiente: { titleKey: 'pendingOrder', descKey: 'pendingOrderDesc' },
    Entregado: { titleKey: 'deliveredOrder', descKey: 'deliveredOrderDesc' },
    default: { titleKey: 'preparingOrder', descKey: 'preparingOrderDesc' },
};

const STATUS_ICON: Record<string, JSX.Element> = {
    success: <CheckCircle size={82} color="#70C516" weight="bold" />,
    pending: <PendingStatusIcon />,
    error:   <ErrorStatusIcon />,
};

const STATUS_TEXT: Record<string, { titleKey: string; messageKey: string }> = {
    success: { titleKey: 'paymentCompleted', messageKey: 'paymentConfirmedMsg' },
    test:    { titleKey: 'paymentTestModeCompleted', messageKey: 'paymentTestModeConfirmedMsg' },
    pending: { titleKey: 'pendingPay',       messageKey: 'messagePendingPay' },
    error:   { titleKey: 'rejectPay',        messageKey: 'messageRejectPay' },
};

const PurchaseDetailAveonline: FunctionComponent<Props> = ({
    purchase,
    transactionState,
    homeState,
    payment,
    items,
    idCart,
    handlePrint,
    status,
    handleCheckout,
    loading,
    isTestTransaction,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const lang = language[homeState.default_language];
    const accentColor = homeState.color || '#F5821F';
    const isEsp = homeState.default_language === 'ESP';

    // Modo prueba de esta transaccion (x_test_request), lo resuelve el contenedor
    const isTestMode = !!isTestTransaction;
    const [copied, setCopied] = useState(false);
    const [rebuying, setRebuying] = useState(false);

    const guideData = purchase.guide?.['aveonline']?.data;
    const aveonlineShipping = purchase.shipping?.aveonline;
    const orderNumber: string | null =
        purchase.guideId ?? guideData?.guia ?? null;
    const trackingInternalUrl: string | null =
        purchase.trackingInternalUrl ??
        (purchase.id
            ? `/vende/${homeState.catalogueUrlName}/guide/${encodeURIComponent(
                  String(purchase.id),
              )}`
            : null);

    const carrierName: string =
        purchase.carrier?.nameCarrier ??
        purchase.carrier?.name ??
        aveonlineShipping?.nameCarrier ??
        purchase.shipping?.deliveryCarrierName ??
        purchase.shipping?.nameCarrier ??
        purchase.shipping?.operador ??
        '';
    const pendingDeliveryTimeText = isEsp ? 'Por confirmar' : 'To be confirmed';

    const formatAmount = (amount: number): string => {
        const homeState_currency = homeState.currency || 'COP';
        if (homeState_currency === 'USD') {
            return `${formatMoney(amount, { symbol: '$', thousand: ',', decimal: '.', precision: 0 })} USD`;
        }
        return `${formatMoney(amount, { symbol: '$', thousand: '.', decimal: ',', precision: 0 })} COP`;
    };

    const formatTransactionDate = (dateStr: string): string => {
        if (!dateStr) return '';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return '';
        const [day, month, year] = parts;
        if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) return '';
        return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    };

    const formatTime12h = (time24h: string): string => {
        if (!time24h) return '';
        const [h, m] = time24h.split(':').map(Number);
        if (isNaN(h) || isNaN(m)) return '';
        const period = h >= 12 ? 'PM' : 'AM';
        const h12 = h % 12 || 12;
        return `${String(h12).padStart(2, '0')}:${String(m).padStart(2, '0')} ${period}`;
    };

    const getDateFromPurchase = (): { date: string; time: string } => {
        if (!purchase.date) return { date: '', time: '' };
        const d = new Date(purchase.date);
        if (isNaN(d.getTime())) return { date: '', time: '' };
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const hours = d.getHours();
        const minutes = d.getMinutes();
        const period = hours >= 12 ? 'PM' : 'AM';
        const h12 = hours % 12 || 12;
        return {
            date: `${dd}/${mm}/${d.getFullYear()}`,
            time: `${String(h12).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`,
        };
    };

    const purchaseDateFallback = getDateFromPurchase();
    const displayDate =
        (transactionState.transactionDate && formatTransactionDate(transactionState.transactionDate)) ||
        purchaseDateFallback.date;
    const displayTime =
        (transactionState.transactionTime && formatTime12h(transactionState.transactionTime)) ||
        purchaseDateFallback.time;

    const formatDate = (value: Date): string => {
        const dd = String(value.getDate()).padStart(2, '0');
        const mm = String(value.getMonth() + 1).padStart(2, '0');
        return `${dd}/${mm}/${value.getFullYear()}`;
    };

    const parseDeliveryDate = (value: unknown): Date | null => {
        if (!value) return null;

        if (value instanceof Date) {
            return isNaN(value.getTime()) ? null : value;
        }

        if (typeof value === 'string') {
            const trimmed = value.trim();
            const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(trimmed);
            if (match) {
                const day = Number(match[1]);
                const month = Number(match[2]);
                const year = Number(match[3]);
                const parsed = new Date(year, month - 1, day);
                if (
                    parsed.getFullYear() === year &&
                    parsed.getMonth() === month - 1 &&
                    parsed.getDate() === day
                ) {
                    return parsed;
                }
            }

            const isoParsed = new Date(trimmed);
            if (!isNaN(isoParsed.getTime())) {
                return isoParsed;
            }
        }

        return null;
    };

    const addBusinessDays = (baseDate: Date, days: number): Date => {
        const result = new Date(baseDate);
        let added = 0;
        while (added < days) {
            result.setDate(result.getDate() + 1);
            if (result.getDay() !== 0 && result.getDay() !== 6) added++;
        }
        return result;
    };

    const getEstimatedDelivery = (): { dayName: string; date: string } => {
        const daysDeliveryRaw =
            purchase.carrier?.daysDelivery ??
            aveonlineShipping?.daysDelivery ??
            purchase.shipping?.daysDelivery;

        const parsedDeliveryDate = parseDeliveryDate(daysDeliveryRaw);
        const baseDate = purchase.date ? new Date(purchase.date) : new Date();
        const fallbackDays = 3;

        const estimatedDate = parsedDeliveryDate
            ? parsedDeliveryDate
            : addBusinessDays(baseDate, fallbackDays);

        const dayNames = isEsp ? DAY_NAMES_ESP : DAY_NAMES_ENG;
        return {
            dayName: dayNames[estimatedDate.getDay()],
            date: formatDate(estimatedDate),
        };
    };

    const getOrderStatus = () => {
        const key = STATUS_MAP[purchase.stateDelivery] ?? STATUS_MAP['default'];
        return { title: lang[key.titleKey], description: lang[key.descKey] };
    };

    const fallbackCopy = (text: string) => {
        const el = document.createElement('textarea');
        el.value = text;
        el.style.position = 'fixed';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    const handleCopy = () => {
        const text = orderNumber ?? '';
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).catch(() => fallbackCopy(text));
        } else {
            fallbackCopy(text);
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleFollowOrder = () => {
        if (trackingInternalUrl) {
            history.push(`${trackingInternalUrl}?from=purchase`);
        } else {
            history.push(`/vende/${homeState.catalogueUrlName}`);
        }
    };

    const handleBuyAgain = () => {
        if (rebuying) return;
        if (!items || items.length === 0) {
            history.push(`/vende/${homeState.catalogueUrlName}`);
            return;
        }
        setRebuying(true);
        try {
            dispatch(
                handleRebuyFromPurchase(
                    items,
                    path,
                    homeState.catalogueName,
                    homeState.default_language,
                    history,
                    purchase?.clientId,
                ) as any,
            );
        } catch (_) {
            setRebuying(false);
        }
    };

    const handleReturnToOriginalCart = () => {
        const cartId = idCart || purchase?.id;
        if (!cartId) {
            history.push(`/vende/${homeState.catalogueUrlName}`);
            return;
        }
        history.push(`/vende/${homeState.catalogueUrlName}/carrito/${cartId}?from=purchase`);
    };

    const getProductImage = (product: any): string => {
        const referenceImg = product?.references?.[0]?.data?.img;
        if (
            product.references?.length > 0 &&
            typeof referenceImg === 'string' &&
            referenceImg !== '' &&
            !referenceImg.endsWith('/null')
        ) {
            return referenceImg;
        }
        return product.productData.img?.[0] ?? '';
    };

    const getUnitLabel = (qty: number): string =>
        qty === 1 ? lang['piece'] : lang['pieces'];

    const estimated = getEstimatedDelivery();
    const orderStatus = getOrderStatus();

    const isTestModeStatus = status === 'success' && isTestMode ? 'test' : status;
  
    const content = (
        <AveonlineWrapper $status={status}>
            {/* ── Cabecera condicional por estado ── */}
            {status === 'success' && (
                <StatusHeader>
                    {STATUS_ICON[status]}
                    <h2>{lang[STATUS_TEXT[isTestModeStatus].titleKey]}</h2>
                    <p>{lang[STATUS_TEXT[isTestModeStatus].messageKey]}</p>
                </StatusHeader>
            )}

            {status === 'pending' && (
                <StatusBannerCard>
                    {STATUS_ICON[status]}
                    <h2>{lang[STATUS_TEXT[status].titleKey]}</h2>
                    <p>{lang[STATUS_TEXT[status].messageKey]}</p>
                </StatusBannerCard>
            )}

            {status === 'error' && (
                <StatusHeader>
                    {STATUS_ICON[status]}
                    <h2>{lang[STATUS_TEXT[status].titleKey]}</h2>
                    <p>{lang[STATUS_TEXT[status].messageKey]}</p>
                    <ErrorActions>
                        <FilledButton
                            $accentColor={accentColor}
                            onClick={handleCheckout}
                            disabled={loading || !handleCheckout}
                        >
                            {lang['chooseOtherPaymentMethod']}
                        </FilledButton>
                        <CancelLink onClick={() => history.push(`/vende/${homeState.catalogueUrlName}`)}>
                            {lang['cancel']}
                        </CancelLink>
                    </ErrorActions>
                </StatusHeader>
            )}

            {/* ── SUCCESS ONLY: Tarjeta pedido + valor ── */}
            {status === 'success' && (
                <>
                    <OrderSummaryCard>
                        <CardRow>
                            <CardColLeft>
                                <Label>{lang['orderNumber']}</Label>
                                {orderNumber ? (
                                    <>
                                        <OrderNumberRow>
                                            {orderNumber}
                                            <CopyButton onClick={handleCopy} title="Copiar">
                                                <CopyIcon size={21} />
                                            </CopyButton>
                                            {copied && <CopiedFeedback>{lang['copied']}</CopiedFeedback>}
                                        </OrderNumberRow>
                                    </>
                                ) : (
                                    <>
                                      <OrderNumberRow>
                                        <p style={{ margin: '0' }}>{isTestMode ? lang['aveGeneratingGuideTest'] : lang['aveGeneratingGuide']}</p>
                                      </OrderNumberRow>
                                    </>
                                )}
                                {(purchase.contactEmail || purchase.email) ? (
                                    <EmailMessage>
                                        <strong>{lang['emailConfirmationMsg']}</strong>{' '}
                                        <strong>{purchase.contactEmail || purchase.email}</strong>
                                        {lang['emailConfirmationMsg2']}
                                    </EmailMessage>
                                ) : (
                                    <EmailMessage>
                                        <strong>{lang['emailConfirmationMsg']}</strong>
                                        {lang['emailConfirmationMsg2']}
                                    </EmailMessage>
                                )}
                            </CardColLeft>
                            <CardColRight>
                                <Label>{lang['valuePaid']}</Label>
                                <Amount>{formatAmount(Math.abs(payment))}</Amount>
                                <SubLabel>{lang['orderDetail']}</SubLabel>
                                {displayDate && <DateText>{displayDate}</DateText>}
                                {displayTime && <DateText>{displayTime}</DateText>}
                            </CardColRight>
                        </CardRow>
                    </OrderSummaryCard>

                    <NextStepCard>
                        <CardRow>
                            <CardColLeft>
                                <Label>{lang['nextStep']}</Label>
                                <StatusTitle>{orderStatus.title}</StatusTitle>
                                <StatusDescription>{orderStatus.description}</StatusDescription>
                            </CardColLeft>
                            <CardColRight>
                                <Label>{lang['estimatedDelivery']}</Label>
                                <DayName>{estimated.dayName}</DayName>
                                <DateText>{estimated.date}</DateText>
                            </CardColRight>
                        </CardRow>
                        <PrimaryActionButton $accentColor={accentColor} onClick={handleFollowOrder}>
                            {lang['followOrder']}
                        </PrimaryActionButton>
                    </NextStepCard>
                </>
            )}

            {/* ── SUCCESS + PENDING: Detalles del envío + productos + footer ── */}
            {status !== 'error' && (() => {
                const ShippingCard = status === 'success' ? ShippingSummaryCard : ShadowCard;
                return (
                <>
                    <SectionTitle>{lang['shippingDetailTitle']}</SectionTitle>

                    <ShippingCard>
                        <ShippingGrid>
                            <ShippingCol>
                                <Label>{lang['customerData']}</Label>
                                <ShippingValue>{purchase.contactName}</ShippingValue>
                            </ShippingCol>
                            <ShippingCol>
                                <Label>{lang['address']}</Label>
                                <ShippingValue>{purchase.address}</ShippingValue>
                            </ShippingCol>
                            <ShippingCol>
                                <Label>{lang['phone']}</Label>
                                <ShippingValue>{purchase.contactPhone}</ShippingValue>
                            </ShippingCol>
                        </ShippingGrid>

                        <ShippingGrid3>
                            <ShippingCol>
                                <Label>{lang['deliveryMethod']}</Label>
                                <ShippingValue>{carrierName || (status === 'pending' ? pendingDeliveryTimeText : '—')}</ShippingValue>
                            </ShippingCol>
                            <ShippingCol>
                                <Label>{status === 'success' ? lang['estimatedDelivery'] : lang['deliveryDate']}</Label>
                                <ShippingValue>{estimated.date}</ShippingValue>
                            </ShippingCol>
                            {status === 'pending' && (
                                <ShippingCol>
                                    <Label>{lang['deliveryTime']}</Label>
                                    <ShippingValue>{pendingDeliveryTimeText}</ShippingValue>
                                </ShippingCol>
                            )}
                        </ShippingGrid3>
                    </ShippingCard>

                    {items.length > 0 && (
                        <ProductsSectionWrapper>
                            <ProductsSection>
                                {items.map((product: any, idx: number) => {
                                    const qty =
                                        (product.references?.length > 0
                                            ? product.references[0].quantity
                                            : product.quantity) || 1;
                                    const referenceText = getReferenceDisplayText(
                                        product,
                                        homeState.default_language
                                    );
                                    return (
                                        <ProductRow key={idx}>
                                            <ProductName>{product.productData.title}</ProductName>
                                            <ProductMeta>
                                                {qty} {getUnitLabel(qty)}
                                            </ProductMeta>
                                            {referenceText && (
                                                <ProductMeta>{referenceText}</ProductMeta>
                                            )}
                                            {!referenceText && <ProductMeta></ProductMeta>}
                                            <ProductThumb
                                                src={getProductImage(product)}
                                                alt={product.productData.title}
                                            />
                                        </ProductRow>
                                    );
                                })}
                            </ProductsSection>
                        </ProductsSectionWrapper>
                    )}

                    <FooterRow>
                        <TextLink $accentColor="#000" onClick={handlePrint}>
                            <PrinterIcon width={21} height={18} />
                            {lang['print']}
                        </TextLink>
                        <OutlineButton
                            $accentColor={accentColor}
                            onClick={() => history.push(`/vende/${homeState.catalogueUrlName}`)}
                        >
                            {lang['goToHomePage']}
                        </OutlineButton>
                        <FilledButton
                            $accentColor={accentColor}
                            onClick={status === 'pending' ? handleReturnToOriginalCart : handleBuyAgain}
                            disabled={status === 'success' && rebuying}
                        >
                            {status === 'success' && rebuying ? (lang['loading'] || 'Cargando...') : lang['backShoping']}
                        </FilledButton>
                    </FooterRow>
                </>
                );
            })()}

        </AveonlineWrapper>
    );

    if (status === 'error' || status === 'pending') {
        return (
            <StatusBackdropFrame $accentColor={accentColor}>
                {content}
            </StatusBackdropFrame>
        );
    }

    return content;
};

export default PurchaseDetailAveonline;
